import { Button } from "antd";
import { useMoralis, useWeb3ExecuteFunction } from "react-moralis";
import AccountPage from "./Account/AccountPage";
import ChainsPage from "./Chains/ChainsPage";
import PresaleDetail from "./PresaleDetails";

const styles = {
  text: {
    fontSize: "20px",
    fontWeight: "700",
    display: "block",
  },
  button: {
    width: "100%",
    marginTop: "50px",
    marginBottom: "50px",
    background:
      "linear-gradient(to right bottom, rgb(255 0 223), rgb(67 0 175))",
    border: "0",
    borderRadius: "5px",
    color: "#FFFFFF",
    cursor: "pointer",
    display: "inline-block",
    fontFamily: "verdana",
    textTransform: "uppercase",
    fontSize: "16px",
    fontWeight: "600",
    outline: "transparent",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "15px",
    paddingRight: "15px",
    textAlign: "center",
    textDecoration: "none",
    transition: "box-shadow .2s ease-in-out",
    userSelect: "none",
    WebkitUserSelect: "none",
    touchAction: "manipulation",
    whiteSpace: "nowrap",
    boxShadow:
      "rgb(0 0 0 / 50%) 0px 0px 0.25rem, rgb(239 0 255 / 50%) -0.125rem -0.125rem 1rem, rgb(0 43 255 / 50%) 0.125rem 0.125rem 1rem",
  },
  buttongiveaway: {
    backgroundColor: "red",
    borderRadius: "5px",
    color: "white",
    borderColor: "white",
    border: "solid",
    cursor: "pointer",
    fontWeight: "bold",
    padding: "5px 10px",
    textAlign: "center",
    transition: "200ms",
    width: "100%",
    boxSizing: "border-box",
    border: "0",
    fontSize: "14px",
    userSelect: "none",
    marginTop: "10px",
  },
  buttonnotready: {
    backgroundColor: "transparent",
    borderRadius: "5px",
    color: "red",
    //cursor: "pointer",
    fontWeight: "300",
    padding: "5px 10px",
    textAlign: "center",
    transition: "200ms",
    width: "100%",
    boxSizing: "border-box",
    border: "1px solid red",
    fontSize: "14px",
    userSelect: "none",
  },
  buttonwallet: {
    backgroundColor: "red",
    borderRadius: "12px",
    color: "white",
    cursor: "pointer",
    fontWeight: "bold",
    padding: "5px 10px",
    textAlign: "center",
    transition: "200ms",
    width: "100%",
    boxSizing: "border-box",
    border: "1",
    borderColor: "red",
    fontSize: "14px",
    userSelect: "none",
  },
  status: {
    fontSize: "15px",
    fontWeight: "400",
    color: "white",
    fontFamily: "verdana",
    textTransform: "uppercase",
    width: "350px",
    border: "0px solid",
    padding: "25px",
    textAlign: "center",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    borderRadius: "5px",
    backgroundColor: "transparent",
    marginTop: "50px",
  },
  notconnected: {
    fontSize: "15px",
    fontWeight: "400",
    color: "red",
    fontFamily: "verdana",
    textTransform: "uppercase",
    width: "350px",
    border: "1px solid red",
    padding: "25px",
    textAlign: "center",
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    borderRadius: "5px",
    backgroundColor: "transparent",
    marginTop: "50px",
  },
};

const ABI = [
  {
    inputs: [
      { internalType: "string", name: "_name", type: "string" },
      { internalType: "string", name: "_symbol", type: "string" },
      { internalType: "string", name: "_initBaseURI", type: "string" },
      { internalType: "string", name: "_initNotRevealedUri", type: "string" },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        button: {
          width: "100%",
          marginTop: "20px",
          marginBottom: "20px",
          background:
            "linear-gradient(to right bottom, rgb(255 0 223), rgb(67 0 175))",
          border: "0",
          borderRadius: "12px",
          color: "#FFFFFF",
          cursor: "pointer",
          display: "inline-block",
          fontFamily: "verdana",
          textTransform: "uppercase",
          fontSize: "16px",
          fontWeight: "600",
          outline: "transparent",
          padding: "0 1rem",
          textAlign: "center",
          textDecoration: "none",
          transition: "box-shadow .2s ease-in-out",
          userSelect: "none",
          WebkitUserSelect: "none",
          touchAction: "manipulation",
          whiteSpace: "nowrap",
          boxShadow:
            "rgb(0 0 0 / 50%) 0px 0px 0.25rem, rgb(239 0 255 / 50%) -0.125rem -0.125rem 1rem, rgb(0 43 255 / 50%) 0.125rem 0.125rem 1rem",
        },
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      { indexed: false, internalType: "bool", name: "approved", type: "bool" },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "from", type: "address" },
      { indexed: true, internalType: "address", name: "to", type: "address" },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "Withdraw",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "activateOnlyOwnerSale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "activatePresaleOne",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "activatePresaleTwo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "activatePublicSale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "owner", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseExtension",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cost",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "getApproved",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "address", name: "operator", type: "address" },
    ],
    name: "isApprovedForAll",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isOneActive",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isOwnerSaleActive",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isPublicSaleActive",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isTwoActive",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxTxMintAmount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_to", type: "address" },
      { internalType: "uint256", name: "_mintAmount", type: "uint256" },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "_newCost", type: "uint256" }],
    name: "newCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "notRevealedUri",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bool", name: "_state", type: "bool" }],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_user", type: "address" }],
    name: "removeWhitelistUserWLone",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_user", type: "address" }],
    name: "removeWhitelistUserWLtwo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "reveal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revealed",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "bytes", name: "_data", type: "bytes" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_newAmountWalletOne", type: "uint256" },
    ],
    name: "setAmountWalletOne",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_newAmountWalletTwo", type: "uint256" },
    ],
    name: "setAmountWalletTwo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "operator", type: "address" },
      { internalType: "bool", name: "approved", type: "bool" },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "_newBaseExtension", type: "string" },
    ],
    name: "setBaseExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "_newBaseURI", type: "string" }],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setCostOne",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setCostTwo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "_notRevealedURI", type: "string" },
    ],
    name: "setNotRevealedURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setOwnerCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setPublicCost",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "_newWalletAddress", type: "address" },
    ],
    name: "setWalletAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newWalletAddressTwo",
        type: "address",
      },
    ],
    name: "setWalletAddressTwo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "uint256", name: "_newmaxTxMintAmount", type: "uint256" },
    ],
    name: "setmaxTxMintAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "supplyOne",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "supplyTwo",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "bytes4", name: "interfaceId", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "index", type: "uint256" }],
    name: "tokenByIndex",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "owner", type: "address" },
      { internalType: "uint256", name: "index", type: "uint256" },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "from", type: "address" },
      { internalType: "address", name: "to", type: "address" },
      { internalType: "uint256", name: "tokenId", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "viewCost",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "wallet",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_owner", type: "address" }],
    name: "walletOfOwner",
    outputs: [{ internalType: "uint256[]", name: "", type: "uint256[]" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "walletTwo",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "whitelistOne",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "", type: "address" }],
    name: "whitelistTwo",
    outputs: [{ internalType: "bool", name: "", type: "bool" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_user", type: "address" }],
    name: "whitelistUserWLone",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "_user", type: "address" }],
    name: "whitelistUserWLtwo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export default function MintNFT() {
  const { Moralis } = useMoralis();
  const contractProcessor = useWeb3ExecuteFunction();

  async function mint() {
    // nft presale one active?
    let saleOneOptions = {
      contractAddress: "0xB8e85B6789997BBA27914BEceb763a6E22b1e0D5",
      functionName: "isOneActive",
      abi: ABI,
    };
    // nft presale one active?
    const presaleOne = await Moralis.executeFunction(saleOneOptions);
    console.log(presaleOne);

    // nft presale two active?
    let saleTwoOptions = {
      contractAddress: "0xB8e85B6789997BBA27914BEceb763a6E22b1e0D5",
      functionName: "isTwoActive",
      abi: ABI,
    };
    // nft presale two active?
    const presaleTwo = await Moralis.executeFunction(saleTwoOptions);
    console.log(presaleTwo);

    // nft presale pubic active?
    let publicSaleOptions = {
      contractAddress: "0xB8e85B6789997BBA27914BEceb763a6E22b1e0D5",
      functionName: "isPublicSaleActive",
      abi: ABI,
    };
    // nft presale one active?
    const isPublicSaleActive = await Moralis.executeFunction(publicSaleOptions);
    console.log(isPublicSaleActive);

    // cost set up
    let costOptions = {
      contractAddress: "0xB8e85B6789997BBA27914BEceb763a6E22b1e0D5",
      functionName: "cost",
      abi: ABI,
    };
    var cost = await Moralis.executeFunction(costOptions);

    if (isPublicSaleActive == true) {
      var calCosts = cost / cost - 0.97; // 0.03
    } else if (presaleOne == true) {
      var calCosts = cost / cost - 0.99; // 0.01
    } else if (presaleTwo == true) {
      var calCosts = cost / cost - 0.98; // 0.02
    } else {
      var calCosts = 0.01; // admin sale
    }
    console.log(calCosts, "this is cost");

    //current connected user
    const user = Moralis.User.current();
    const useraddress = user.attributes.ethAddress;
    // mint
    let options = {
      contractAddress: "0xB8e85B6789997BBA27914BEceb763a6E22b1e0D5",
      functionName: "mint",
      abi: ABI,
      params: {
        _to: useraddress,
        _mintAmount: 1,
      },
      msgValue: Moralis.Units.ETH(calCosts),
    };

    await contractProcessor.fetch({
      params: options,
    });
  }

  function DiscordLink() {
    window.open("https://twitter.com", "_blank");
  }

  const { isAuthenticated, account } = useMoralis();

  if (isAuthenticated == true || account == true) {
    return (
      <div>
        {/*    <ChainsPage />*/}
        <button style={styles.buttonnotready}>
          {" "}
          Presale ROUND ONE has not started yet
        </button>
        <button style={styles.buttongiveaway} onClick={() => DiscordLink()}>
          👉 Get Whitelisted
        </button>
        <p style={styles.status} className="statusText">
          LOREM IPSUM DOLOR SIT AMET, CONSECTETUR ADIPISCING ELIT, SED DO
          EIUSMOD TEMPOR INCIDIDUNT UT LABORE ET DOLORE MAGNA ALIQUA.
        </p>
        <button style={styles.button} /*onClick={() => mint()}*/>
          {" "}
          Mint Awesome NFT
        </button>
        <PresaleDetail />
      </div>
    );
  } else {
    return (
      <div>
        <AccountPage />
        <p style={styles.status} className="statusText">
          LOREM IPSUM DOLOR SIT AMET, CONSECTETUR ADIPISCING ELIT, SED DO
          EIUSMOD TEMPOR INCIDIDUNT UT LABORE ET DOLORE MAGNA ALIQUA.
        </p>
        <PresaleDetail />
      </div>
    );
  }
}
